export class TipoPlantillaCorreoEnvio {
   nombre: string;
   tipoPlantillaEnvioCorreoId: number;
   activo: boolean;
}
